export default "/assets/images/technology-hero-sm.jpg?d43de2e7961a8a693d3fa43258d6dbf7";